export const HOST =
  window.location.href.indexOf("3000") > 0
    ? "https://localhost:5001"
    : window.location.href.indexOf("staging") > 0
    ? "https://northwindpostaging.groupetoundra.com"
    : "";

export const IsProduction = window.location.href.indexOf("northwindpo.groupetoundra.com") > 0; //HOST === 'prodUrlInspectionListBackend';
export const IsStaging = window.location.href.indexOf("northwindpostaging.groupetoundra.com") > 0; //HOST === 'prodUrlInspectionListBackend';
